export default "__VITE_ASSET__f6a6388a__"